// Shared save/cancel buttons for settings tabs
import React from "react";

const SettingsSaveButtons = ({
  onSave,
  onCancel,
  saving = false,
  hasChanges = false,
}) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        padding: "20px 0",
        borderTop: "1px solid #e5e7eb",
        marginTop: "32px",
        position: "sticky",
        bottom: 0,
        background: "white",
        zIndex: 10,
      }}
    >
      {hasChanges && (
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          style={{
            padding: "12px 24px",
            background: "#6b7280",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: saving ? "not-allowed" : "pointer",
            opacity: saving ? 0.5 : 1,
          }}
        >
          Cancel
        </button>
      )}
      <button
        type="submit"
        onClick={onSave}
        disabled={saving || !hasChanges}
        style={{
          padding: "12px 24px",
          background: hasChanges ? "#10b981" : "#9ca3af",
          color: "white",
          border: "none",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: "500",
          cursor: saving || !hasChanges ? "not-allowed" : "pointer",
          opacity: saving ? 0.7 : 1,
        }}
      >
        {saving ? "Saving..." : hasChanges ? "Save Changes" : "No Changes"}
      </button>
    </div>
  );
};

export default SettingsSaveButtons;
